import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatCurrency } from "web_myplann/Infrastructure/Utils/CurrencyUtils";
import {
	EARLY_FREEDOM_SCENARIO_LABELS,
	INSPIRATION_CURRENCY,
} from "web_myplann/Inspiration/constants";
import type {
	EarlyFreedomContext,
	EarlyFreedomScenarioKey,
} from "web_myplann/Inspiration/Utils/earlyFreedomMath";
import {
	getEarlyFreedomScenario,
	getEarlyFreedomScenarioRatePercent,
} from "web_myplann/Inspiration/Utils/earlyFreedomMath";

const R = Resources.Inspiration.EarlyFreedom;

export const useEarlyFreedomAdvisorMessage = () => {
	const { t } = useResource();

	return (
		context: EarlyFreedomContext,
		scenarioKey: EarlyFreedomScenarioKey,
	) => {
		const amount = (value: number) =>
			formatCurrency(value, INSPIRATION_CURRENCY, 0);

		if (context.isEarlyFreedomReady)
			return t(R.advisorMessageReady, {
				targetExpenses: amount(context.targetExpenses),
				passiveIncome: amount(context.passiveToday),
				coverage: context.coverageRatio,
			});

		const scenario = getEarlyFreedomScenario(context, scenarioKey);

		return t(R.advisorMessage, {
			targetIncome: amount(context.gap),
			targetCapital: amount(context.targetCapital),
			monthlySaving: amount(context.monthlySaving),
			scenario: t(EARLY_FREEDOM_SCENARIO_LABELS[scenarioKey]),
			rate: getEarlyFreedomScenarioRatePercent(scenario),
		});
	};
};
